import { getContentValue } from '@truqc/content-path';
import store from '../reducers/storeRegistration';
import serverNativeBehaviorEvaluator from './serverNativeBehaviorEvaluator';

/**
 * Manage a web cache of getFormContentBehavior results
 * This web native behavior wraps the server getFormContentBehavior with client-side caching
 * Forms are preloaded from the server and stored in formCache, so this wrapper checks
 * the cache before making remote requests. Cache is automatically cleared when forms
 * are unloaded via clearEditorCache.
 *
 * @param {Object} entity - The entity object
 * @param {string} entityName - The name of the entity
 * @param {Object} source - The source object with type 'getFormContentBehavior' and uuid
 * @param {Object} content - The content object
 * @param {string} parentContentPath - The parent content path
 * @param {Object} transientContext - The transient context object
 * @param {Object} nativeFunctions - The native functions object
 * @param {Object} sourceEvaluator - The source evaluator object
 * @returns {*} The form content from cache or server
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  // Only handle getFormContentBehavior requests with uuid
  if (!(source !== null && source !== void 0 && source.uuid)) {
    // Fall through to server if uuid is missing
    return serverNativeBehaviorEvaluator.evaluate(entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
  }
  const state = store.getState();
  // Redux store key is always 'form' (lowercase), regardless of source.entityName
  const formEntityName = 'form';
  const _ref = state[formEntityName] || {},
    _ref$editorCache = _ref.editorCache,
    editorCache = _ref$editorCache === void 0 ? {} : _ref$editorCache;
  const cacheName = "formCache/".concat(source.uuid);

  // Check cache first (handles preloaded forms from server)
  const cachedForm = getContentValue(cacheName, editorCache);
  if (cachedForm !== undefined && cachedForm.overview !== true) {
    // Cache hit with full content - return without making remote request
    return cachedForm;
  }

  // Cache miss or overview-only (e.g. from formSearchField) - fetch full content from server
  return serverNativeBehaviorEvaluator.evaluate(entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
};
export default {
  evaluate
};